import Error404 from '@/apps/Error404'
import Layout from '@/apps/layout/components'
import React from 'react'

const Page404 = (): React.ReactElement => {
  return (
    <Layout isFooter={false}>
      <Error404 />
    </Layout>
  )
}

export default Page404
